<template>
    <div>
<!--&lt;!&ndash;      <breadcrumb :routerList="[{to:'/invoice/applyList',title:'可开票确认'},{title:'可开票确认详情'}]"/>&ndash;&gt;-->
      <Breadtabsheader/>
      <div class="h-content">
                <div class="h-piece">
                        <div class="h-formBox">
                          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" @submit.native.prevent>
                              <div class="h-thirdColumn w-newColumn" >
                                <el-form-item label="供应商" >
                                  <el-input clearable v-model="q.supplierCode"></el-input>
                                </el-form-item>
                                <el-form-item label="公司主体" >
                <brselect category="kkber_value_kp" v-model="q.companyCode" clearable :v="q.companyCode"
                  @change="handleFilter"></brselect>
                                </el-form-item>
                                <el-form-item label="是否确认" v-if="third">
                                  <el-select v-model="q.confirmed" @change="dataUpdate" :clearable="true">
                                    <el-option label="已确认" value="1"></el-option>
                                    <el-option label="未确认" value="0"></el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="状态" v-if="third">
                                  <el-select v-model="q.status" @change="dataUpdate" :clearable="true">
                                    <el-option label="正常" value="0"></el-option>
                                    <el-option label="冻结" value="3"></el-option>
                                  </el-select>
                                </el-form-item>

                                <el-form-item label="报关单号" prop="customsCode" v-if="!third" style="width: 50%;">
                                  <el-input v-model="q.customsCode" placeholder="多单号模糊查询请用空格或分号分隔"></el-input>
                                </el-form-item>

                              </div>

                            <el-collapse-transition>
                              <div v-show="isScreen">

                            <div class="h-thirdColumn w-newColumn" >
                              <el-form-item label="采购订单号" prop="cgCode" style="width: 50%;">
                                <el-input v-model="q.cgCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                              </el-form-item>

                              <el-form-item label="sap订单号" prop="orderNumber" style="width: 50%;">
                                <el-input v-model="q.orderNumber" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                              </el-form-item>
                            </div>
                            <div class="h-thirdColumn w-newColumn" >
                              <el-form-item label="申请单号" prop="cgCode" v-if="third" style="width: 50%;">
                                <el-input v-model="q.billNo" placeholder="多单号模糊查询请用空格或分号分隔"></el-input>
                              </el-form-item>

                              <el-form-item label="发票编码" prop="orderNumber" style="width: 50%;" v-if="third">
                                <el-input v-model="q.invoiceNumber" placeholder="多编码模糊查询请用空格或分号分隔"></el-input>
                              </el-form-item>
                            </div>
                              <div class="h-thirdColumn w-newColumn" >
                                <el-form-item label="发票状态"  v-if="third">
                                  <el-select v-model="q.ifCheck" @change="dataUpdate" :clearable="true">
                                    <el-option label="未提报" value="0"></el-option>
                                    <el-option label="审核中" value="1"></el-option>
                                    <el-option label="审核通过" value="2"></el-option>
                                    <el-option label="驳回" value="3"></el-option>
                                  </el-select>
                                </el-form-item>
                              </div>
                                <div class="h-thirdColumn w-newColumn" >
                                  <el-form-item label="审核状态"  v-if="!third">
                                    <el-select v-model="q.confirmFlag" @change="changeConfirmFlag" :clearable="true">
                                      <el-option label="已审核" value="1"></el-option>
                                      <el-option label="未审核" value="0"></el-option>
                                    </el-select>
                                  </el-form-item>
                                </div>
                              </div>
                            </el-collapse-transition>
                            </el-form>
                          <div class="l-screenBox">
                            <div class="l-screen" @click="collapseChange">
                              <img :src="isScreen?closeScreen:drawScreen" alt="">
                              <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                            </div>
                            <div class="l-retrieval">
                              <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
                              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            </div>
                          </div>
                        </div>
                </div>
          <div class="h-row">
        <div class="h-rowIn" style="width:100%;">
          <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">
            <div class="h-rowTitle h-pdl0">
              <div class="h-el-tab">
<!--                <ul>-->
<!--                  <li :class="{ 'h-active': index == indx }" v-for="(item, index) in list" :key="index"-->
<!--                    @click="tabIndex(item)"><a>{{ item }}</a></li>-->
<!--                </ul>-->
                    <ul>
                      <li :class="{ 'h-active': indx == 0 }" v-if="!isTuishui || isAll" @click="tabIndex('月结')"><a>月结</a></li>
                      <li :class="{ 'h-active': indx == 1 }" v-if="!isTuishui || isAll" @click="tabIndex('预付')"><a>预付</a></li>
                      <li :class="{ 'h-active': indx == 2 }"v-if="isTuishui || isAll" @click="tabIndex('退税')"><a>退税</a></li>
                    </ul>
<!--                <el-tabs v-model="activeName" type="border-card" @tab-click="tabIndex($event)">-->
<!--                  <el-tab-pane label="月结" name="first" >月结</el-tab-pane>-->
<!--                  <el-tab-pane label="预付" name="second">预付</el-tab-pane>-->
<!--                  <el-tab-pane label="退税" name="third" >退税</el-tab-pane>-->
<!--                </el-tabs>-->
              </div>
            </div>
            <el-table max-height="500px" size="mini" ref="multipleTable" :data="tableData" :border="true"
                      tooltip-effect="dark" @selection-change="handleSelectionChange" style="width: 100%" v-if="!third">
              <el-table-column type="selection" width="40" fixed="left">
              </el-table-column>
              <el-table-column type="index" width="45" fixed="left" label="#">
              </el-table-column>
              <el-table-column prop="supplierName" label="供应商" fixed="left" width="260" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  {{ scope.row.supplierName }}-{{ scope.row.supplierCode }}
                </template>
              </el-table-column>

              <el-table-column prop="customsCode" label="报关单号" width="180" fixed="left"> </el-table-column>
              <el-table-column prop="sapCode" label="销售单号" width="100" fixed="left" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="cgCode" label="采购订单号" width="100" fixed="left" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="ycId" label="预测单号" width="110" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="gscode" label="公司代码" width="90" v-if="!third"> </el-table-column>
              <el-table-column prop="proType" label="产品属性"  width="80"> </el-table-column>
              <el-table-column prop="proNumber" label="报关订单数量" width="80"> </el-table-column>
              <el-table-column prop="unitPrice" label="单价"  width="80"> </el-table-column>
              <el-table-column prop="amount" label="未税金额"  width="90">
                <template slot-scope="scope">
                  {{ fun(scope.row.amount) }}
                </template>
              </el-table-column>
              <el-table-column prop="includeTaxAmount" label="含税金额"  width="90">
                <template slot-scope="scope">
                  {{ fun(scope.row.includeTaxAmount) }}
                </template>
              </el-table-column>
              <el-table-column prop="cgCount" label="采购订单数量" > </el-table-column>
              <el-table-column prop="taxCode" label="税率" width="80">
                <template slot-scope="scope">
                  <dictname category="cgshuilv" :v="scope.row.taxCode" />
                </template>
              </el-table-column>
              <el-table-column prop="currency" label="币种"> </el-table-column>
<!--              <el-table-column prop="orderQuantity" label="收货总数量" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="amountAll" label="订单总金额" :show-overflow-tooltip="true"> </el-table-column>-->
              <el-table-column prop="spbmjcmtlgroupname" label="开票名称" width="150"> </el-table-column>
              <el-table-column prop="chineseName" label="服务名称" width="150"> </el-table-column>
              <el-table-column prop="declarationName" label="规格型号" width="150"> </el-table-column>
              <el-table-column prop="primaryuom" label="单位" width="80"> </el-table-column>
              <el-table-column prop="orderDate" label="订单创建时间" width="110" :formatter="formatDate"></el-table-column>
              <el-table-column prop="confirmFlag" label="是否审核" width="110">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.confirmFlag == 1">已审核</span>
                    <span v-if="scope.row.confirmFlag == 0">未审核</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-table max-height="500px" size="mini" ref="multipleTable" :data="tableData" :border="true"
              tooltip-effect="dark" @selection-change="handleSelectionChange" style="width: 100%" v-if="third">
              <el-table-column type="selection" width="40" fixed="left">
              </el-table-column>
              <el-table-column type="index" width="45" fixed="left" label="#">
              </el-table-column>
              <el-table-column prop="supplierName"  label="供应商" fixed="left" width="260" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  {{ scope.row.supplierName }}-{{ scope.row.supplierCode }}
                </template>
              </el-table-column>
              <el-table-column prop="companyCode"  label="采购公司" fixed="left" width="100" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="orderDate"  label="订单日期" width="110" :formatter="formatDate"
                :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="cgCode"  label="采购订单号" width="110" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="orderNumber"  label="sap订单号" width="110" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="org" label="采购组织" width="80" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="moduleName" label="产品型号" width="110" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="orderQuantity" label="订单数量" width="110" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="amount" label="订单未税金额" width="110" :show-overflow-tooltip="true">
              </el-table-column>

              <el-table-column prop="includeTaxAmount" label="订单含税金额" width="110" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="taxCode" label="税率" width="80">
                <template slot-scope="scope">
                  <dictname category="cgshuilv" :v="scope.row.taxCode" />
                </template>
              </el-table-column>
              <el-table-column prop="currency" label="币种" width="80" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column prop="confirmed" label="是否确认" width="110" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.confirmed == 1">已确认</span>
                    <span v-if="scope.row.confirmed == 0">未确认</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="confirmedTime" label="确认时间" value-format="yyyy-MM-dd" width="120">
              </el-table-column>
              <el-table-column prop="confirmedUsername" label="确认人" width="100">
              </el-table-column>
              <el-table-column prop="billNo" :show-overflow-tooltip="true" label="申请单号" width="100">
              </el-table-column>
              <el-table-column prop="invoiceNumber" :show-overflow-tooltip="true" label="发票号" width="100">
              </el-table-column>
              <el-table-column prop="invoiceDate" label="发票日期" width="120">
              </el-table-column>
              <el-table-column prop="createTimeInvoice" value-format="yyyy-MM-dd" label="发票创建日期" width="120">
              </el-table-column>
              <el-table-column prop="ifCheck" label="开票状态" width="110" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.ifCheck == 1">审核中</span>
                    <span v-if="scope.row.ifCheck == 0">未提报</span>
                    <span v-if="scope.row.ifCheck == 2">审核通过</span>
                    <span v-if="scope.row.ifCheck == 3">驳回</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="status" label="冻结状态" width="110" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.status == 0">正常</span>
                    <span v-if="scope.row.status == 3">冻结</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="freezeUserName" label="冻结人" width="100">
              </el-table-column>
              <el-table-column prop="freezeDate" label="冻结时间" value-format="yyyy-MM-dd" width="100">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="left" style="height: 50px">
        <div style="justify-content: space-between;flex-direction:row-reverse;margin-top:1px">
          <span>合计金额：</span><span style="color: red">{{ form.totalMoney }}</span>
        </div>
        <el-button class="h-btn h-formBtn h-bgblueQ" v-show="third"  @click="submit" v-if="">提交</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="third"
          @click="exportExcel">导出</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="!third"
                   @click="exportExcelTs">导出</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ" @click="createApply" v-if="third">生成发票</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ" @click="approved" v-if="!third">提交到供应商</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ" @click="createApplyTs" v-if="!third">生成发票</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ"  v-show="third" @click="freezeSrmByInvoiceList" v-if="">批量冻结</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ"  v-show="third" @click="thawSrmByInvoiceList" v-if="">批量解冻</el-button>
        <pagination :page="q" @query="checkData" />
      </div>

      <createApply :visible.sync="showInvoiceDialog" v-if="showInvoiceDialog" @saveorsubmit="closeDialog"
        :orderList="this.multipleSelection" :supplierCode="this.supplierCode" :supplierName="this.supplierName"
        :companyCode="this.companyCode" title="创建发票" />

      <createApplyTs :visible.sync="showInvoiceDialogTs" v-if="showInvoiceDialogTs" @saveorsubmit="closeDialogTs"
                   :orderList="this.multipleSelection" :supplierCode="this.supplierCode" :supplierName="this.supplierName"
                   :companyCode="this.org" :companyCodeType="this.gscode" title="创建发票" />

        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import createApply from '../apply/createApplyToSrm'
    import createApplyTs from '../apply/createApplyToSrmTs'
    export default {
        name: "alluser",
        components: {createApply,createApplyTs,},
        data(){
            return {
                id:null,
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                supplierCode:null,
                supplierName:null,
                soldToCode:null,
                soldToName:null,
                companyCode:null,
                org:null,
                gscode:null,
                form:{
                  pageSize: 10,
                  pageNo: 1,
                },
                tableData:[],
                fileList:[],
                multipleSelection:[],//选中的数据
                q:{
                  pageSize: 10,
                  pageNo: 1,
                  total: 0
                },
                //查询属性
                isCheck:null,
                showInvoiceDialog:false,
                showInvoiceDialogTs:false,
                isTuishui:false,
                isAll:false,
                activeName: 'first',
                ids:'',
                indx: 0,
                item:'',
      list: ['月结', '预付', '退税'],
                chartPer: {
                  yj : 0,
                  yf : 0,
                  ts: 0,
        // 补  退税
                },
      third: true
            }
        },
        methods: {
          fun(val){
            return Number(val).toFixed(3);
          },
            handleFilter(){

      if( this.third == false){
        console.log("这是测试")
        console.log("this.third", this.third)
        //
        ss.invoiceApplyList.selectPageDrawback(this.q).then(rd => {
        console.log("这是第三个返回数据rd", rd);
        this.form = rd.records;
        this.tableData = rd.records;
        this.q.total = rd.total;
        var sum = 0;
        /*  this.form.forEach(element => {
            sum += element.includeTaxAmount;
          });*/
        this.form.totalMoney = sum.toFixed(2);
          //进行强制数据渲染
          this.$forceUpdate();
      });
      }else {
        console.log("queryquery",this.q);
        ss.invoiceApplyList.selectInvoices(this.q).then(rd=> {
          console.log("rd",rd);
          this.form=rd.records;
          this.tableData = rd.records;
          this.q.total = rd.total;
          var sum = 0;
          /*  this.form.forEach(element => {
              sum += element.includeTaxAmount;
            });*/
          this.form.totalMoney = sum.toFixed(2);
        });
        //进行强制数据渲染
        this.$forceUpdate();
      }
            },
            checkData(){
              this.handleFilter();
            },
            // 展开折叠
            collapseChange(){
              this.isScreen = !this.isScreen;
            },
            exportExcel(){
              var q = this.q;
              q.id=this.id;
              updownfile.down("/api/swyl/v1/demo/bscSrmInvoiceDetail/downloadExcelAll",q,"get",'params');
            },
            exportExcelTs(){
              var q = this.q;
              q.id=this.id;
              updownfile.down("/api/swyl/v1/demo/bscTaxInvoice/downloadTaxExcel",q,"get",'params');
            },
            resetData(){
              this.q.companyCode = '';
              this.q.orderNumber = '';
              this.q.status = '';
              this.q.supplierCode = '';
              this.q.confirmed = '';
              this.q.cgCode = '';
              this.q.billNo = '';
              this.q.invoiceNumber = '';
              this.q.ifCheck = '';
              this.q.customsCode = '';
            },

            handlePreview(file){

                window.open(file.saveurl);
            },


            //方法区
            formatDate(row, column) {
                // 获取单元格数据
                let date = row[column.property];
                if (date) {
                    return this.transformDate(date)
                } else {
                    return ''
                }
            },
            //标准时间格式转yyyy-MM-dd
            transformDate(date) {
                if (date) {
                    let dt = new Date(date);
                    return dt.getFullYear() + '-' +
                        ((dt.getMonth() + 1) < 10 ? ('0' + (dt.getMonth() + 1)) : (dt.getMonth() + 1)) + '-' +
                        (dt.getDate() < 10 ? ('0' + dt.getDate()) : dt.getDate());
                } else {
                    return ''
                }
            },
          //勾选事件
          handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log("val",val);
            var sum = 0;
            this.multipleSelection.forEach(element => {
              element.syNum = element.availableNum - element.proNumber;
              sum += element.includeTaxAmount;
            });
            this.supplierCode=val[0].supplierCode;
            this.soldToCode=val[0].soldToCode;
            this.soldToName=val[0].soldToName;
            this.companyCode=val[0].companyCode;
            this.gscode=val[0].gscode;
            this.org=val[0].org;
            this.supplierName=val[0].supplierName;
            this.form.totalMoney = sum.toFixed(2);
            //进行强制数据渲染
            this.$forceUpdate();
          },
          //提交到SRM后改变状态
            submit(){
              if(this.multipleSelection.length==0){
                this.$message.error("请选择需要提交的数据");
                return;
              }
              let query = [];
              for(var i=0;i<this.multipleSelection.length;i++){
                let querys = {};
                querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
                querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
                querys.id = this.multipleSelection[i].id;
                querys.status = this.multipleSelection[i].status;
                query.push(querys);
              }
              console.log(query);
              ss.invoiceApplyList.sendSrmByInvoice(query).then(rd=> {
                console.log("rd",rd);
                if(rd.f){
                  this.$msg.msgs("提交成功！")
                  this.checkData();
                }
              });
            },
            dataUpdate() {
              this.$forceUpdate()
            },
            //返回上页
            fanhuishangye() {
              //跳转
              this.$router.push("/invoice/applyList");
            },
            createApply(){
                if(this.multipleSelection.length==0){
                    this.$message.error("请选择需要提交的明细");
                    return;
                }
                //只能勾选未确认的数据
                var confirmFlag = false;
                this.multipleSelection.forEach(element => {
                    if(element.confirmed == 1){
                        confirmFlag = true;
                    }
                });
                if(confirmFlag){
                    this.$message.error("只能勾选未确认的数据，请重新选择！");
                    return;
                }
                this.showInvoiceDialog = true;
            },
            approved(){
              if(this.multipleSelection.length==0){
                this.$message.error("请选择需要提交的明细");
                return;
              }
              let query = [];
              for(var i=0;i<this.multipleSelection.length;i++){
                let querys = {};
                querys.id = this.multipleSelection[i].taxId;
                querys.confirmFlag = this.multipleSelection[i].confirmFlag;
                query.push(querys);
              }
              console.log(query);
              ss.invoiceApplyList.transferSupplier(query).then(rd=> {
                console.log("rd",rd);
                if(rd.f){
                  this.$msg.msgs("提交成功！")
                  this.checkData();
                }
              });
            },
            createApplyTs(){
              if(this.multipleSelection.length==0){
                this.$message.error("请选择需要提交的明细");
                return;
              }
              //勾选同一个采购订单
              var cgFlag = false;
              var cgCodes = this.multipleSelection[0].cgCode;
              var customsCodes = this.multipleSelection[0].customsCode;
              this.multipleSelection.forEach(element => {

                if(customsCodes != element.customsCode){
                  cgFlag = true;
                }
              });
              if(cgFlag){
                this.$message.error("请勾选同一报关单号和采购订单号数据！");
                return;
              }
              this.showInvoiceDialogTs = true;
            },
            closeDialog(){
                this.showInvoiceDialog = false;
                this.handleFilter();
            },
            closeDialogTs(){
              this.showInvoiceDialogTs = false;
              this.handleFilter();
            },
          changeConfirmFlag(val){
            this.q.confirmFlag = val
            //进行强制数据渲染
            this.$forceUpdate();
          },
          freezeSrmByInvoiceList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            console.log(this.multipleSelection);
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.confirmed = this.multipleSelection[i].confirmed;
              query.push(querys);
            }
            console.log(query);
            ss.invoiceApplyList.freezeSrmByInvoiceList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("冻结成功！")
                this.checkData();
              }
            });
          },
          thawSrmByInvoiceList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.freezeUser = this.multipleSelection[i].freezeUser;
              querys.confirmed = this.multipleSelection[i].confirmed;
              query.push(querys);
            }
            console.log(query);
            ss.invoiceApplyList.thawSrmByInvoiceList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("解冻成功！")
                this.checkData();
              }
            });
          },
          //全部/已转化/为转化标签
          tabIndex(i) {
            this.item = i;
            console.log("iiiii",i);
            if (this.item == '预付') {
              this.q.invoiceType = 1;
              this.third = true
              this.indx = 1;
              this.checkData();
            } else if (this.item == '月结') {
              this.q.invoiceType = 0;
              this.indx = 0;
              this.third = true
              this.checkData();
            } else if (this.item == '退税') {
              console.log("这个是第三个",)
              this.q.invoiceType = 2;
              this.indx = 2;
              this.third = false
              console.log("this.third", this.third)
              this.checkData();
            }
        },

        },
        created(){
            this.q.confirmed = '0';
            this.q.confirmFlag = '0';
            this.q.invoiceType = 0;
            this.checkData();
            this.isTuishui = this.$store.getters.hasRole('tuishui_jl');
            if(this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('kaipiao_all')){
              this.isAll = true;
            }
        },
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuqiuBoxList .xuqiulist.active {
      background: #238cfd;
      border: 1px solid #238cfd;
      color: #fff;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
    .w-tongyi {
        padding: 0.1rem 0.25rem;
    }
    .tan.h-formBorder .h-elformWrap-2{
        width: 50%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__label{
        width: 22%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__content{
        width: 78%;
    }
    /deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip{
        　　display: none !important;
    }
</style>
